/*
 * PROTECTED FILE — DO NOT MODIFY WITH LOVABLE AI OR ANY AI CODE TOOL.
 * PRIVATE_PATTERNS is the global noindex guard. Every route in this array is protected
 * from Google indexing. Adding a new private/auth-gated route? Add it here — never per-page.
 * Removing any entry exposes private pages to Google and breaks GSC coverage health.
 * Use Dev Mode only. See CLAUDE.md before making any changes.
 */
import { useLocation, matchPath } from "@/lib/router-compat";
import { Helmet } from "@/lib/helmet-compat";

/**
 * Globally injects noindex/nofollow meta for private/auth/admin routes so they
 * never appear in Google with the generic homepage title. Public, indexable
 * pages should declare their own <PageMeta /> with title/description/canonical.
 *
 * Pattern matches use react-router's matchPath so dynamic segments are covered.
 */
const PRIVATE_PATTERNS = [
  "/auth",
  "/reset-password",
  "/onboarding",
  "/onboarding/*",
  "/profile/complete",
  "/dashboard",
  "/dashboard/*",
  "/admin",
  "/admin/*",
  "/agent-auth",
  "/agent-dashboard",
  "/agent-dashboard/*",
  "/expert-dashboard",
  "/expert-dashboard/*",
  "/experts",
  "/experts/*",
  "/expert-qa",
  "/learn/ruben",
  "/employer-onboarding",
  "/employer-dashboard",
  "/employer-dashboard/*",
  "/employer-report",
  "/wellness-survey",
  "/pulse",
  "/lp/hero-stack/thank-you",

  "/share-progress",
  "/share-progress/*",
  "/preview/*",
  "/lifemart/hook-preview",
  "/lifemart/free-credit-score",
  "/lifemart/stack-offer",
  "/lifemart/stack",
  "/embed/*",
  "/expert-followup/*",
  "/member-followup/*",
  "/stack-check/*",
  "/decks/*",
  "/points-store",
  "/success-stories",
  "/neighborhood-watchlist",
  "/goals",
];


const RouteMetaGuard = () => {
  const { pathname } = useLocation();
  const isPrivate = PRIVATE_PATTERNS.some((p) =>
    matchPath({ path: p, end: !p.endsWith("/*") }, pathname),
  );
  if (!isPrivate) return null;
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow, noarchive" />
    </Helmet>
  );
};

export default RouteMetaGuard;